import MessageTemplate from '@/api/message-template'

interface State {
  templates: {}
  autoInputIndex: number
}

const defaultState: State = {
  templates: {},
  autoInputIndex: -1
}

const state: State = Object.assign({}, defaultState)

const mutations = {
  resetState(state: State) {
    const s = defaultState
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },

  setTemplates(state: State, templates: {}) {
    state.templates = templates
  },
  setAutoInputIndex(state: State, index: number) {
    state.autoInputIndex = index
  }
}

const actions = {
  /**
   * テンプレート一覧の取得
   */
  fetchTemplates({ commit }, payload): Promise<any> {
    return MessageTemplate.fetchTemplates(payload).then(data => {
      if (data.templates) {
        commit('setTemplates', data.templates)
      }
      return data
    })
  },

  /**
   * テンプレートの作成と編集
   */
  editTemplate({}, payload): Promise<any> {
    return MessageTemplate.editTemplate(payload)
  },

  /**
   * テンプレートの削除
   */
  removeTemplate({ state }, payload): Promise<any> {
    return MessageTemplate.removeTemplate(payload).then(data => {
      if (!data.error && payload.id) {
        delete state.templates[payload.id]
      }
      return data
    })
  },

  /**
   * 自動入力設定
   */
  autoInput({}, payload): Promise<any> {
    return MessageTemplate.autoInput(payload).then(data => {
      return data
    })
  }
}

const getters = {
  templates: (state: State): {} => state.templates,
  autoInputIndex: (state: State): number => state.autoInputIndex
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
